export default __webpack_public_path__ + "static/media/NGIF Accelerator Logo resized.79693133.png";